import React, { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { NavLink } from 'react-router';
import styled from 'styled-components';

//#region styled
const CenterWrapper = styled.div`
  text-align: center;
`;

const ModeContainer = styled.div`
  display: inline-block;
  margin-bottom: 15px;
  background: rgb(51, 63, 72);
`;

const ModeLink = styled(NavLink)`
  display: inline-block;
  border: 1px solid #666;
  padding: 10px 35px;
  text-decoration: none;

  border-right-width: 0;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.45);

  &:nth-child(4) {
    border-right-width: 1px;
  }

  &.active {
    background: none;
    color: rgba(255, 255, 255, 0.85);
  }

  &:hover {
    color: rgba(255, 255, 255, 0.85);
    background: rgba(255, 255, 255, 0.07);
  }
`;

//#endregion

class ReportViews extends Component<WithTranslation, any> {
  constructor(props) {
    super(props);
  }

  public render() {
    const { t } = this.props;

    const { customersUrl, tanksUrl, billingUrl, entriesUrl } = {
      tanksUrl: '/reports/tank',
      billingUrl: '/reports/billing',
      customersUrl: '/reports/customer',
      entriesUrl: '/reports/bookkeepingEntries'
    };

    return (
      <CenterWrapper>
        <ModeContainer>
          <ModeLink to={tanksUrl}>
            {t('pages.reporting.tanks')}
          </ModeLink>
          <ModeLink to={customersUrl}>
            {t('pages.reporting.customers')}
          </ModeLink>
          <ModeLink to={entriesUrl}>
            {t('pages.reporting.all_entries')}
          </ModeLink>
        </ModeContainer>
      </CenterWrapper>
    );
  }
}

export default withTranslation()(ReportViews);
